import(/* webpackMode: "eager" */ "/app/app/(data-intensive)/project/epic/[id]/page.tsx");
